import classNames from 'clsx';
import React from 'react';

import type { AppFooterContent } from '@swf/cms';
import type { WidgetFC, WidgetInstanceProps } from '@swf/core/types/Widget';
import type { AppFooterContentWidgetServices } from '@swf/generated/types/widgets/AppFooterContentWidget';

import styles from './AppFooterContentWidget.scss';
import Item from './components/Item';

export interface Data {
  section: AppFooterContent;
}

export type Props = WidgetInstanceProps<unknown, AppFooterContentWidgetServices, Data>;

/* eslint-disable @typescript-eslint/naming-convention */
const AppFooterContentWidget: WidgetFC<Props> = ({ data, style }) => {
  const section = data?.section;
  const repeatFit = section?.background_fit === 'repeat';
  const fitAlign = !repeatFit ? section?.background_fit || 'left' : 'left';

  return section ? (
    <div className={styles.container} style={style}>
      <div
        style={{
          backgroundColor: section.background_color,
          backgroundImage: `url(${section.background_image?.asset?.url})`,
          backgroundPosition: fitAlign,
          backgroundRepeat: repeatFit ? 'repeat' : 'no-repeat'
        }}
        className={styles.background}
      >
        <div className={classNames(styles[`col${section.number_of_columns}`], styles.grid)}>
          {section.items.length &&
            section.items.map((item, index) => (
              <Item {...item} alignment={section.item_alignment} key={index} />
            ))}
        </div>
      </div>
    </div>
  ) : null;
};

export default AppFooterContentWidget;
